module.exports = __webpack_public_path__ + "img/Educational.c053fa4e.svg";